import type { FunctionCallingConfigFormToolField } from "components/formControls/FunctionCallingConfigControl/types";
import log from "loglevel";

const STORAGE_KEY_PREFIX = "tool_config_";

const getStorageKey = (entityId: string) => `${STORAGE_KEY_PREFIX}${entityId}`;

interface StoredToolConfig {
  description: string;
  isApprovalRequired: boolean;
}

export const storeToolConfig = (entityId: string, config: StoredToolConfig) => {
  try {
    sessionStorage.setItem(getStorageKey(entityId), JSON.stringify(config));
  } catch (error) {
    log.error("Failed to store tool config:", error);
  }
};

export const getStoredToolConfig = (
  entityId: string,
): StoredToolConfig | null => {
  try {
    const stored = sessionStorage.getItem(getStorageKey(entityId));

    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    log.error("Failed to retrieve tool config:", error);

    return null;
  }
};

export const storeToolConfigs = (
  tools: FunctionCallingConfigFormToolField[],
) => {
  tools.forEach((tool) => {
    storeToolConfig(tool.entityId, {
      description: tool.description,
      isApprovalRequired: tool.isApprovalRequired,
    });
  });
};

export const restoreToolConfig = <T extends { entityId: string }>(
  tool: T,
  storedConfig: StoredToolConfig | null,
): T & Partial<StoredToolConfig> => {
  if (!storedConfig) {
    return tool;
  }

  return {
    ...tool,
    description: storedConfig.description,
    isApprovalRequired: storedConfig.isApprovalRequired,
  };
};
